import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import AntCheckbox from "antd/es/checkbox/index.js";
import MultipleChoiceListCommon, { wrapperProps } from '@data-driven-forms/common/multiple-choice-list';
import FormGroup from '../form-group';

var FinalCheckbox = function FinalCheckbox(_ref) {
  var isDisabled = _ref.isDisabled,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AntCheckbox, _extends({}, props, {
    disabled: isDisabled
  }), label);
};

FinalCheckbox.propTypes = {
  isDisabled: PropTypes.bool,
  label: PropTypes.node
};

var Wrapper = function Wrapper(_ref2) {
  var label = _ref2.label,
      isRequired = _ref2.isRequired,
      children = _ref2.children,
      meta = _ref2.meta,
      validateOnMount = _ref2.validateOnMount,
      helperText = _ref2.helperText,
      description = _ref2.description,
      FormItemProps = _ref2.FormItemProps;
  return /*#__PURE__*/React.createElement(FormGroup, {
    label: label,
    meta: meta,
    validateOnMount: validateOnMount,
    helperText: helperText,
    description: description,
    FormItemProps: FormItemProps,
    isRequired: isRequired
  }, children);
};

Wrapper.propTypes = _objectSpread({}, wrapperProps);

var MultipleChoiceList = function MultipleChoiceList(props) {
  return /*#__PURE__*/React.createElement(MultipleChoiceListCommon, _extends({}, props, {
    Wrapper: Wrapper,
    Checkbox: FinalCheckbox
  }));
};

MultipleChoiceList.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired
  })
};
export default MultipleChoiceList;